import FluxStore from "./FluxStore";

import AppConstants from "../constants/AppConstants";

import AppDispatcher from "../dispatcher/AppDispatcher";

// Define initial data points
let budgetAllocations = [];
let budgetTemplates = [];
let initialized = false;

// Extend BudgetStore with EventEmitter to add eventing capabilities
class BudgetStore extends FluxStore
{
	constructor()
	{
		super();
	}

	getIsInitialized()
	{
		return initialized;
	}

	getAllocations()
	{
		return budgetAllocations;
	}

	getTemplates()
	{
		return budgetTemplates;
	}
}

const budgetStore = new BudgetStore();

budgetStore.dispatchToken = AppDispatcher.register((action) => {
	let transferDetails = action.transferDetails;
	let fromAllocation;
	let toAllocation;

	switch (action.actionType) {
		case AppConstants.BUDGET_RECEIVE_DATA:
			initialized = true;
			budgetAllocations = action.budgetAllocations;
			budgetTemplates = action.budgetTemplates;
			break;

		case AppConstants.BUDGET_TEMPLATE_RUN_SUCCESS:
		case AppConstants.BUDGET_ALLOCATIONS_SETORDER_SUCCESS:
		case AppConstants.RELOAD_DATA:
			if (action.hasOwnProperty("budgetAllocations"))
			{
				budgetAllocations = action.budgetAllocations;
				let index = budgetTemplates.findIndex(template => template.id === action.id);
				if (index !== -1)
				{
					budgetTemplates.splice(index, 1, action.budgetTemplate);
				}
			}
			else
			{
				// No-op
				return true;
			}
			break;

		case AppConstants.BUDGET_ALLOCATIONS_TRANSFER_PENDING:
			fromAllocation = budgetAllocations.find(allocation => allocation.categoryId === transferDetails.fromCategoryId && allocation.currencyId === transferDetails.currencyId);
			toAllocation = budgetAllocations.find(allocation => allocation.categoryId === transferDetails.toCategoryId && allocation.currencyId === transferDetails.currencyId);
			if (!fromAllocation)
			{
				fromAllocation = {
					id: -1,
					amount: 0,
					categoryId: transferDetails.fromCategoryId,
					currencyId: transferDetails.currencyId
				};
				budgetAllocations.push(fromAllocation);
			}
			if (!toAllocation)
			{
				toAllocation = {
					id: -1,
					amount: 0,
					categoryId: transferDetails.toCategoryId,
					currencyId: transferDetails.currencyId
				};
				budgetAllocations.push(toAllocation);
			}
			fromAllocation.amount -= +(transferDetails.amount);
			toAllocation.amount += +(transferDetails.amount);
			break;

		case AppConstants.BUDGET_ALLOCATIONS_TRANSFER_SUCCESS: {
			let updatedAllocations = action.allocations;
			for (let index = budgetAllocations.length - 1; index >= 0; --index)
			{
				if (budgetAllocations[index].id === -1)
				{
					budgetAllocations.splice(index, 1);
				}
			}
			for (let index = updatedAllocations.length - 1; index >= 0; --index)
			{
				let id = updatedAllocations[index].id;
				let allocationIndex = budgetAllocations.findIndex(budgetAllocation => budgetAllocation.id === id);
				if (allocationIndex === -1)
				{
					budgetAllocations.push(updatedAllocations[index]);
				}
				else
				{
					budgetAllocations[allocationIndex] = updatedAllocations[index];
				}
			}
			break;
		}

		case AppConstants.BUDGET_ALLOCATIONS_TRANSFER_FAILURE:
			// TODO: BA-152 show error message some way
			for (let index = budgetAllocations.length - 1; index >= 0; --index)
			{
				if (budgetAllocations[index].id === -1)
				{
					budgetAllocations.splice(index, 1);
				}
			}
			fromAllocation = budgetAllocations.find(allocation => allocation.categoryId === transferDetails.fromCategoryId && allocation.currencyId === transferDetails.currencyId);
			toAllocation = budgetAllocations.find(allocation => allocation.categoryId === transferDetails.toCategoryId && allocation.currencyId === transferDetails.currencyId);
			if (fromAllocation)
			{
				fromAllocation.amount += +(transferDetails.amount);
			}
			if (toAllocation)
			{
				toAllocation.amount -= +(transferDetails.amount);
			}
			break;

		case AppConstants.BUDGET_TEMPLATE_SAVE_SUCCESS:
		{
			if (action.isNew)
			{
				budgetTemplates.push(action.budgetTemplate);
			}
			else
			{
				const index = budgetTemplates.findIndex(template => template.id === action.budgetTemplate.id);
				budgetTemplates[index] = action.budgetTemplate;
			}
			break;
		}

		case AppConstants.BUDGET_TEMPLATE_DELETE_PENDING: {
			// Optimistic render
			let index = budgetTemplates.findIndex(template => template.id === action.id);
			if (index !== -1)
			{
				budgetTemplates.splice(index, 1);
			}
			break;
		}

		default:
			return true;
	}

	// If action was responded to, emit change event
	budgetStore.emitChange();
	return true;
});

export default budgetStore;



// WEBPACK FOOTER //
// ./Components/stores/BudgetStore.jsx